const { Client } = require("@stomp/stompjs");

const stompClient = new Client({
  brokerURL: window.config.RMQConfig.URL,
  connectHeaders: {
    login: window.config.RMQConfig.User,
    passcode: window.config.RMQConfig.Pass,
    host: window.config.RMQConfig.VirtualHost,
  },
  // debug: function (str) {
  //   console.log("[STOMP DEBUG]:", str);
  // },
  reconnectDelay: 5000,
  heartbeatIncoming: 10000,
  heartbeatOutgoing: 10000,
});

export default stompClient;
